<template>

<div>
  <div class="row">
    <div class="form-group col-lg-4">
      <label for="isActive">{{ $t('status') }}</label>
      <Combobox
        class="bg-white"
        name='isActive'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="status"
        v-model="filter"
        :reduce="status => status.label"
      />
    </div>
  </div>

  <b-alert
    :show="alert.show"
    @dismissed='alert.show = false'
    dismissible
    fade
    variant="success"
  >
    {{ alert.message }}
  </b-alert>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        small
        class="bg-white"
        :items="vehicles"
        :fields='fieldsVehicles'
        :filter="filter"
      >
        <template v-slot:cell(newOffset)=value>
          <input
            type="text"
            name="newOffset"
            class="form-control text-right"
            :placeholder="$t('ph_newOffset')"
            v-model="offsets[value.index]"
          >
        </template>

        <template v-slot:cell(VEI_ID)=value>
          <b-button
            variant='primary'
            size="sm"
            pill
            @click="setOffset({
              newOffset: value.item.newOffset,
              vehicleId: value.item.VEI_ID
            })"
            class="mr-1"
          >
            <i class="fas fa-satellite-dish" />
          </b-button>

          <b-button
            variant='primary'
            size="sm"
            pill
            data-target="#modalConfirmChangeIP"
            data-toggle="modal"
            :data-id='value.item.VEI_ID'
          >
            IP
          </b-button>
        </template>
      </b-table>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <p>Total: {{ getTotal() }} registro(s)</p>
    </div>
  </div>

  <!-- MODAL CONFIRM CHANGE IP -->
  <div class="modal fade" id="modalConfirmChangeIP" tabindex="-1" role="dialog" aria-labelledby="modalConfirmChangeIPLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalConfirmChangeIPLabel">Alterar IP's</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 id="msgConfirmOs">Deseja enviar o comando para alterar o IP Primário e Secundário para 107.22.49.191:9002?</h3>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            {{ $t('close') }}
          </button>
          
          <button
            type="button"
            class="btn btn-primary"
            @click="setIP"
            data-dismiss="modal"
          >
            {{ $t('send') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment-timezone'
import { request } from '@/lib/http'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'ArenaVehicles2001',
  components: {
    LoaderButton,
    Combobox
  },

  data () {
    return {
      serial: '',
      board: '',
      fieldsVehicles: [
        {
          key: 'VEI_DSC',
          label: this.$t('vehicleId'),
          formatter: (value, item, row) => row.VEI_ID,
          sortable: true
        },
        {
          key: 'VEI_PLC',
          label: this.$t('board'),
          sortable: true
        },
        {
          key: 'EQP_SRN',
          label: this.$t('serial'),
          sortable: true
        },
        {
          key: 'DDL_DH',
          label: this.$t('gps_hour'),
          formatter: value => moment(value).format('DD/MM/YYYY HH:mm:ss'),
          sortable: true
        },
        {
          key: 'RGPS_DHS',
          label: this.$t('server_hour'),
          formatter: value => moment(value).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss'),
          sortable: true
        },
        {
          key: 'RGPS_STS',
          label: 'Status',
          formatter: value => {
            const text = {
              0: 'AGUARDANDO',
              1: 'COMANDO ENVIADO',
              2: 'SERVIDOR ALTERADO'
            }

            return text[value]
          },
          sortable: true,
          filterByFormatted: true
        },
        {
          key: 'VEI_OFF',
          label: 'Offset',
          sortable: true
        },
        {
          key: 'newOffset',
          label: 'Novo Offset',
          sortable: true
        },
        {
          key: 'VEI_ID',
          label: '',
          sortable: true,
          class: ['text-center']
        }
      ],
      vehicles: [],
      vehicleId: undefined,
      alert: {
        show: false,
        message: ''
      },
      offsets: [],
      status: [
        { label: 'AGUARDANDO', value: 0 },
        { label: 'COMANDO ENVIADO', value: 1 },
        { label: 'SERVIDOR ALTERADO', value: 2 }
      ],
      filter: null
    }
  },

  methods: {
    async loadVehicles() {
      const { dispatch } = this.$store
      dispatch('overlay/show', true)

      const allVehicles = await request({
        url   : 'vehicles-arena-2001',
        method: 'get'
      })

      for (const vehicle of allVehicles) {
        this.offsets.push(vehicle.newOffset)
      }

      this.vehicles = allVehicles

      dispatch('overlay/show', false)
    },

    async setOffset(data) {
      const { dispatch } = this.$store
      dispatch('overlay/show', true)

      try {
        await request({
          url   : `position-and-offset/${data.vehicleId}`,
          method: 'patch',
          params: { newOffset: data.newOffset }
        })

        this.alert = {
          show   : true,
          message: 'Offset alterado com sucesso!'
        }

        await this.loadVehicles()
      } catch (error) {
        dispatch('notify/error', { message: error.message })
      } finally {
        dispatch('overlay/show', false)
      }
    },

    async setIP() {
      const { dispatch } = this.$store
      dispatch('overlay/show', true)

      try {
        await request({
          url   : `command-change-ip/${this.vehicleId}`,
          method: 'patch'
        })

        this.alert = {
          show   : true,
          message: 'Comando enviado com sucesso!'
        }

        await this.loadVehicles()
      } catch (error) {
        dispatch('notify/error', { message: error.message })
      } finally {
        dispatch('overlay/show', false)
        $('#modalConfirmChangeIP').modal('hide')
      }
    },

    getTotal() {
      if (this.filter) {
        const text = {
          0: 'AGUARDANDO',
          1: 'COMANDO ENVIADO',
          2: 'SERVIDOR ALTERADO'
        }

        const total = this.vehicles.filter(vehicle => text[vehicle.RGPS_STS] === this.filter)
        
        return total.length
      }

      return this.vehicles.length
    }
  },

  async mounted() {
    await this.loadVehicles()

    const global = this
    $('#modalConfirmChangeIP').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      global.vehicleId = button.data('id')
    })

    $('#modalConfirmChangeIP').on('hide.bs.modal', function (event) {
      global.vehicleId = undefined
    })

    $('#refresh').on('click', function() {
      global.loadVehicles()
    })
  }
}
</script>